import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { SharedUiPropertySpacesWrapper } from '../shared-ui/details/property-spaces-wrapper';
import { SpaceDetailsWrapper } from '../template-components/space-details-wrapper';

export const PropertySpacesExperiment = () => (
  <Experiment name="Vrbex_SUVR_Spaces">
    <ExperimentControl>
      <SpaceDetailsWrapper />
    </ExperimentControl>
    <ExperimentVariant bucket={1}>
      <SharedUiPropertySpacesWrapper />
    </ExperimentVariant>
  </Experiment>
);
